import { useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";

import { BsEye, BsEyeSlash, BsLock, BsPerson } from "react-icons/bs";

import icon from "/icon_tims.png";

import { serviceLogin } from "../../api/serviceApi";

import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //for after login success redirect to the original page where user opened tims like /managejobs/view/<id>
  const [searchParams] = useSearchParams(location.search);
  const redirect = searchParams.get("redirect") || "/";

  const [input, setInput] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (submitting) {
      return;
    }

    const trimmedInput = input.trim();

    if (!trimmedInput || !password) {
      toast.error("Please enter your username and password.");
      return;
    }

    try {
      setSubmitting(true);

      const result = await serviceLogin(trimmedInput, password);

      if (!result?.token || !result?.role) {
        throw new Error("Invalid login response.");
      }

      sessionStorage.setItem("token", result.token);
      sessionStorage.setItem("user_id", result.id || "");
      sessionStorage.setItem("user_name", result.name || "");
      sessionStorage.setItem("user_role", result.role || "");

      toast.success(result.name ? `Welcome, ${result.name}` : "Welcome");

      //try redirect as well
      navigate(redirect, { replace: true });
      // navigate("/");
    } catch (error) {
      console.error("Login error:", error);

      toast.error(error?.message || "User credentials do not match.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login">
      <div className="login-overlay" />

      <section className="login-container">
        {/* LOGO */}

        <div className="login-brand">
          <div className="logo-container">
            <img src={icon} alt="Trucktronix" className="lf-icon" />
          </div>

          <div className="login-brand-copy">
            <span className="login-brand-name">Trucktronix</span>

            <h1 className="lf-title">Inventory Management System</h1>
          </div>
        </div>

        {/* FORM */}

        <form className="lf-form" onSubmit={handleSubmit}>
          {/* USER */}

          <div className="lf-input-group">
            <label htmlFor="input">User</label>

            <div className="lf-input-wrap">
              <BsPerson className="lf-input-icon" />

              <input
                type="text"
                id="input"
                placeholder="Enter username or email"
                className="lf-input"
                value={input}
                disabled={submitting}
                onChange={(event) => setInput(event.target.value)}
                autoComplete="username"
                autoFocus
                required
              />
            </div>
          </div>

          {/* PASSWORD */}

          <div className="lf-input-group">
            <div className="lf-label-row">
              <label htmlFor="password">Password</label>

              <Link
                className="lf-forgot-link"
                to="/reset"
                tabIndex={submitting ? -1 : 0}
              >
                Forgot password?
              </Link>
            </div>

            <div className="lf-input-wrap">
              <BsLock className="lf-input-icon" />

              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter your password"
                value={password}
                className="lf-input lf-password-input"
                disabled={submitting}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />

              <button
                type="button"
                className="lf-toggle-password"
                disabled={submitting}
                onClick={() => setShowPassword((current) => !current)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <BsEyeSlash /> : <BsEye />}
              </button>
            </div>
          </div>

          {/* SUBMIT */}

          <button
            type="submit"
            className="lf-login-button"
            disabled={submitting}
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="login-footer">Sign in to continue your work.</div>
      </section>
    </main>
  );
};

export default Login;

//import ActivityLog from "../activity/ActivityLog";
//import Bowser from "bowser";
// Authenticate user with Firebase
//     signInWithEmailAndPassword(auth, input, password)
//       .then((userCredential) => {
//         const user = userCredential.user;

//         // Store token and input in localStorage
//         localStorage.setItem(
//           "Auth Token",
//           userCredential._tokenResponse.refreshToken,
//         );
//         localStorage.setItem("admin_email", user.input);

//         let encodedEmail = user.input.replace(/\./g, ",");

//         // Fetch user data from Firebase database
//         const dbRef = ref(db, `Users/${encodedEmail}`);
//         onValue(dbRef, (snapshot) => {
//           let fullname = snapshot.val()?.name || user.input;
//           sessionStorage.setItem("admin_name", fullname);
//           localStorage.setItem("admin_name", fullname);
//           // sessionStorage.setItem("admin_email", user.input);

//           //added authorisation type in fb database to check whether admin or b2b
//           let authorisation = snapshot.val()?.authorisation;
//           localStorage.setItem("authorisation_type", authorisation);

//           // const { bname, version } = getBrowserInfo();
//           const { name, version } = Bowser.getParser(
//             window.navigator.userAgent,
//           ).getBrowser();
//           console.log(name, version);
//           ActivityLog(
//             "Login Success",
//             `Logged on from ${name}, version ${version}`,
//           );
//           console.log("token name:", localStorage.getItem("admin_name"));
//           if (authorisation === "admin") {
//           }

//           if (authorisation === "admin") {
//             navigate("/");
//           } else if (authorisation === "b2b") {
//             navigate("/b2b");
//           }
//         });
//       })
//       .catch((error) => {
//         toast.error("Email and password do not match.");
//         console.error("Login Error:", error.code, error.message);
//       });
//   };
